import { useHistory } from 'react-router';
import { useShallow } from 'zustand/react/shallow';
import { getIDFromUrl, Url } from '@rossum/api-client';
import { getAnnotationBacklink } from '../../../routes/useAnnotationBacklink';
import { DocumentDrawer } from '../../document/DocumentDrawer';
import { useDocumentStore } from '../document-store/DocumentStore';

export const ValidationDocumentDrawer = () => {
  const { currentDrawer, annotationId, relationId } = useDocumentStore(
    useShallow(({ currentDrawer, annotationId, relationId }) => ({
      currentDrawer,
      annotationId,
      relationId,
    }))
  );
  const closeDrawer = useDocumentStore(useShallow(state => state.closeDrawer));
  const openDrawer = useDocumentStore(useShallow(state => state.openDrawer));
  const history = useHistory();

  const onAnnotationDelete = (annotation: Url) => {
    if (getIDFromUrl(annotation) === annotationId) {
      // Deleting annotation itself via duplicate drawer
      // Go back in this case.
      const backArrowLink = getAnnotationBacklink();
      history.push(backArrowLink);
    }
  };

  return (
    <DocumentDrawer
      onClose={closeDrawer}
      selectedAnnotationId={annotationId}
      selectedAnnotationView={currentDrawer}
      selectedRelationId={relationId}
      onAnnotationDelete={onAnnotationDelete}
      handleSelectAnnotation={params => {
        openDrawer({
          drawer: params.view,
          annotationId: getIDFromUrl(params.annotationUrl),
          relationId: params.relationId,
        });
      }}
    />
  );
};
